/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StringCriteriaRangeRequest
 */
export interface StringCriteriaRangeRequest {
    /**
     * 
     * @type {string}
     * @memberof StringCriteriaRangeRequest
     */
    from?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StringCriteriaRangeRequest
     */
    to?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof StringCriteriaRangeRequest
     */
    exclude?: boolean;
}

export function StringCriteriaRangeRequestFromJSON(json: any): StringCriteriaRangeRequest {
    return StringCriteriaRangeRequestFromJSONTyped(json, false);
}

export function StringCriteriaRangeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): StringCriteriaRangeRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'from': !exists(json, 'from') ? undefined : json['from'],
        'to': !exists(json, 'to') ? undefined : json['to'],
        'exclude': !exists(json, 'exclude') ? undefined : json['exclude'],
    };
}

export function StringCriteriaRangeRequestToJSON(value?: StringCriteriaRangeRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'from': value.from,
        'to': value.to,
        'exclude': value.exclude,
    };
}


